import { ArrowRight } from 'lucide-react'
import { cn } from '../../utils/cn'

export default function SectionIndex({
  items = [],
  className,
  titleClass = 'text-2xl lg:text-[28px]',
}) {
  return (
    <div
      className={cn(
        'flex w-full flex-col gap-12 py-8 lg:gap-20 lg:px-20 lg:py-16',
        className,
      )}
    >
      {items.map((item, index) => {
        const content = (
          <>
            <span className="font-inter-regular text-2xl tracking-[-0.02em] text-[#AEAEAE]">
              {item.number}
            </span>
            <div className="flex flex-1 flex-col gap-3.5">
              <div className="flex items-center justify-between gap-6">
                <h3
                  className={cn(
                    'font-inter-extrabold uppercase tracking-[-0.02em] text-[#454545]',
                    titleClass,
                  )}
                >
                  {item.title}
                </h3>
                <ArrowRight
                  size={24}
                  strokeWidth={1}
                  className="shrink-0 text-[#454545]/50"
                />
              </div>
              <p className="font-inter-regular text-base leading-[1.1] tracking-[-0.02em] text-[#7B7B7B]">
                {item.description}
              </p>
            </div>
          </>
        )

        const className =
          'flex w-full items-start gap-5 text-left transition-opacity hover:opacity-70 lg:gap-10'

        if (item.href) {
          return (
            <a
              key={item.number ?? index}
              href={item.href}
              onClick={item.onClick}
              className={className}
            >
              {content}
            </a>
          )
        }

        return (
          <button
            key={item.number ?? index}
            type="button"
            onClick={item.onClick}
            className={className}
          >
            {content}
          </button>
        )
      })}
    </div>
  )
}
